import axios from '~/utilities/axiosV2';

const basePath = '/isr/api/v1/broker-dealer-groups';

export default {
  addBrokerDealerGroup({ commit }, body) {
    const payload = {
      ...body,
      issuersData: body.issuersData.map(issuer => ({
        ...issuer,
        issuerId: issuer.id,
        id: undefined,
      })),
    };
    return axios.post(basePath, payload).then(({ data }) => {
      commit('global/CALL_TOASTER', 'B/D Group is added', { root: true });
      return data;
    });
  },
  updateBrokerDealerGroup({ commit }, { body, brokerDealerGroupId }) {
    const payload = {
      name: body.name,
      email: body.email,
      authorizations: body.authorizations,
      issuersData: body.issuersData.map(issuer => ({
        ...issuer,
        issuerId: issuer.id,
        id: undefined,
      })),
    };
    return axios
      .patch(`${basePath}/${brokerDealerGroupId}`, payload)
      .then(() => {
        commit('global/CALL_TOASTER', 'B/D Group is updated', { root: true });
      });
  },
  getBrokerDealerGroupById(ctx, brokerDealerGroupId) {
    return axios
      .get(`${basePath}/${brokerDealerGroupId}`)
      .then(({ data: result }) => ({
        ...result,
        issuersData: result.brokerDealerGroupIssuers.map(issuer => ({
          ...issuer,
          id: issuer.issuerId,
        })),
        authorizations: result.brokerDealerGroupAuthorizations.map(
          ({ authorization }) => authorization,
        ),
      }));
  },
  activateBrokerDealerGroup({ commit }, brokerDealerGroupId) {
    return axios.post(`${basePath}/${brokerDealerGroupId}/enable`).then(() => {
      commit('global/CALL_TOASTER', 'B/D Group is activated', { root: true });
    });
  },
  deactivateBrokerDealerGroup({ commit }, brokerDealerGroupId) {
    return axios.post(`${basePath}/${brokerDealerGroupId}/disable`).then(() => {
      commit('global/CALL_TOASTER', 'B/D Group is deactivated', { root: true });
    });
  },
  getBrokerDealerGroups(ctx, { params }) {
    const preparedParams = {
      issuerId: params['issuer-id'],
      query: params.q?.trim() === '' ? undefined : params.q,
      orderDirection: params['order-direction']?.toUpperCase(),
      orderField: params['order-field'],
      offset: Number(params.page) * Number(params.limit),
      limit: params.limit,
      includes: ['issuers'],
    };
    return axios
      .get(basePath, {
        params: preparedParams,
      })
      .then(({ data: result }) => ({
        data: result.data.map(item => ({
          ...item,
          issuers: item.brokerDealerGroupIssuers.map(issuer => ({
            id: issuer.issuerId,
            name: issuer.name,
          })),
        })),
        totalItems: result.meta.total,
      }))
      .catch((err) => {
        this.$log.error('B/D Groups get error:', err);
        return err;
      });
  },
  getBrokerDealerGroupListDropdown({ commit }) {
    axios
      .get(basePath, {
        params: {
          limit: 1000,
        },
      })
      .then(({ data: { data } }) => commit(
          'SET_BROKER_DEALER_GROUPS_DROPDOWN',
          data.map(({ id, name }) => ({ value: id, text: name })),
        ))
      .catch(error => this.$log.error('Error get B/D Groups list:', error));
  },
};
